import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
interface DocPaginaProps {
  children: React.ReactNode;
}
export function DocPagina(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section data-doc-page={true} className="relative flex h-[1123px] w-[794px] flex-none flex-col overflow-hidden bg-white text-neutral-700 shadow-md">{children}</section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function DocCabecalho() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-[52px] w-full flex-none items-center justify-between border-b border-solid border-neutral-200 px-[37px]"><Image src="/icone.svg" alt="" width={22} height={22} className="h-[22px] w-auto opacity-10" /><Image src="/Logo.svg" alt="Arbitralis" width={85} height={20} className="h-5 w-auto" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface DocRodapeProps {
  /** `null` = documento ainda sem código: o rodapé omite o par, nunca imprime o rótulo sozinho. */
  codigoAutenticacao: string | null;
  urlAutenticacaoExibicao: string | null;
  numeroPagina: number;
  totalPaginas: number;
}
export function DocRodape(t0) {
  const $ = _c(11);
  const {
    codigoAutenticacao,
    urlAutenticacaoExibicao,
    numeroPagina,
    totalPaginas
  } = t0;
  let t1;
  if ($[0] !== codigoAutenticacao) {
    t1 = codigoAutenticacao ? <div className="text-[9px] tracking-[1px] text-neutral-400 uppercase">Código de Autenticação · <span className="font-semibold tracking-[0.5px] text-neutral-500">{codigoAutenticacao}</span></div> : <div />;
    $[0] = codigoAutenticacao;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== urlAutenticacaoExibicao) {
    t2 = <div className="text-[10.5px] text-neutral-400">{urlAutenticacaoExibicao}</div>;
    $[2] = urlAutenticacaoExibicao;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== numeroPagina || $[5] !== totalPaginas) {
    t3 = <div className="text-[11px] text-neutral-400 italic">Página {numeroPagina} de {totalPaginas}</div>;
    $[4] = numeroPagina;
    $[5] = totalPaginas;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="absolute right-[37px] bottom-[20px] left-[37px] flex items-center justify-between border-t border-solid border-neutral-200 pt-[9px]">{t1}{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}